export default __webpack_public_path__ + "static/Plots0005-633b54b822ab5b7b34612678a85789be.jpg";